import uniq from "lodash-es/uniq";
import { Reducer } from "redux";

import {
    STROLLERS_LIST_FETCH_FAILURE,
    STROLLERS_LIST_FETCH_REQUEST,
    STROLLERS_LIST_FETCH_SUCCESS,
    StrollersFetchFailureAction,
    StrollersFetchRequestAction,
    StrollersFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersList.actions";
import {
    initialBrandStrollersListState,
    initialBrandsStrollersListState,
} from "@/mk2/apps/strollers/containers/BrandsStrollersList/BrandsStrollersList.constants";
import { LinkedObjects } from "@/mk2/apps/strollers/containers/StrollersDetail/StrollersDetail.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface BrandStrollersListState {
    strollerIds: number[];
    strollersPreviewPhotoMap: Record<number, number>;
    strollersPhotosIds: number[];
    count: number;
    loadingState: LoadingState;
    errorMessage: string;
    hasMore: boolean;
    brandId: number;
    articleIds: number[];
}

export interface BrandsStrollersListState {
    buyingGuideId: number;
    counsellingId: number;
    forumPostLinkedObjects: LinkedObjects;
    brands: {
        [slug: string]: BrandStrollersListState;
    };
}

type StrollersFetchAction =
    | StrollersFetchRequestAction
    | StrollersFetchSuccessAction
    | StrollersFetchFailureAction;

export const strollersReducer: Reducer<BrandsStrollersListState, StrollersFetchAction> = (
    state = initialBrandsStrollersListState,
    action,
) => {
    const slug = action.slug;

    switch (action.type) {
        case STROLLERS_LIST_FETCH_REQUEST:
        case STROLLERS_LIST_FETCH_FAILURE:
            return {
                ...state,
                brands: tupdate(state.brands, {
                    [slug]: tupdate(state.brands[slug] || initialBrandStrollersListState, {
                        loadingState: loadingState(undefined, action),
                        errorMessage: errorMessage(undefined, action),
                    }),
                }),
            };

        case STROLLERS_LIST_FETCH_SUCCESS: {
            const firstFetch = !action.offset;
            const brandState = state.brands[slug] || initialBrandStrollersListState;
            return {
                ...state,
                brands: tupdate(state.brands, {
                    [slug]: tupdate(brandState, {
                        loadingState: loadingState(undefined, action),
                        errorMessage: errorMessage(undefined, action),
                        strollerIds: uniq([
                            ...brandState.strollerIds,
                            ...action.response.result.strollers,
                        ]),
                        strollersPreviewPhotoMap: tupdate(
                            brandState.strollersPreviewPhotoMap,
                            action.response.result.strollersPreviewPhotoMap,
                        ),
                        strollersPhotosIds: uniq([
                            ...brandState.strollersPhotosIds,
                            ...action.response.result.strollersPhotos,
                        ]),
                        hasMore: action.hasMore,
                        count: firstFetch ? action.count : brandState.count,
                        brandId: action.response.result.brand,
                        articleIds: firstFetch
                            ? action.response.result.articles
                            : brandState.articleIds,
                    }),
                }),
                buyingGuideId: firstFetch
                    ? action.response.result.buyingGuide
                    : state.buyingGuideId,
                counsellingId: firstFetch
                    ? action.response.result.counselling
                    : state.counsellingId,
                forumPostLinkedObjects: firstFetch
                    ? action.forumPostLinkedObjects
                    : state.forumPostLinkedObjects,
            };
        }
        default:
            return state;
    }
};

export default strollersReducer;
